import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { FacturasRegistro, DebitoAutomatico } from 'app/entities/debito-automatico';

@Injectable({
  providedIn: 'root'
})
export class DebitoService {

  constructor(private _http:HttpClient) { }

  public VerBancos(){
    return this._http.get(`${environment.api}debito/bancos`);
  }

  public VerSucursal(){
    return this._http.get(`${environment.api}geo/ciudades/activas`);
  }

  public VerTipoCuenta(){
    return this._http.get(`${environment.api}debito/tipo-cuenta`);
  }

  public VerTipoDocumento(){
    return this._http.get(`${environment.api}debito/tipo-documento`);
  }

  public GuardarDebitoAuto(database: string, grupo: string, form: any){
    return this._http.put(`${environment.api}debito/debito-auto/${database}/${grupo}`, form);
  }

  public QuitarDebitoAuto(database: string, grupo: string){
    return this._http.put(`${environment.api}debito/del-debito/${database}/${grupo}`,{});
  }

  public VerGruposxPeriodoDebito(opcion?: string){
    return this._http.get(`${environment.api}debito/periodo-debito-grupo/${(opcion? opcion : '0')}`)
                      .pipe(map((response: Array<any>) => {
                        response.forEach(element => {
                          element.Facturas = this.toFacturas(element);
                        });
                        return response;
                      }));
  }

  toFacturas(element): Array<FacturasRegistro> {
    // Arreglo que almacenara el objeto Factura y sera retornado //
    let Facturas: Array<FacturasRegistro> = [];

    // Se crean arreglos que despues seran los atributos del objeto Factura //
    let NFacturas = element.Nfacturas ? element.Nfacturas.split('-') : element.Nfacturas;
    let FechaFact = element.FechaFact ? element.FechaFact.split(',') : element.FechaFact;
    let ValorUnit = element.ValorUnit ? element.ValorUnit.split('-') : element.ValorUnit;
    let NvoSaldo = element.NvoSaldo ? element.NvoSaldo.split('-') : element.NvoSaldo;
    let MesCobro = element.MesCobro ? element.MesCobro.split('-') : element.MesCobro;

    for (let i = 0; i < (NFacturas? NFacturas.length : 0); i++) {
      // Formamos el Objeto Factura //
      let Factura: FacturasRegistro = {
        Nfacturas: NFacturas[i],
        FechaFact: FechaFact[i],
        ValorUnit: ValorUnit[i],
        NvoSaldo: NvoSaldo[i],
        MesCobro: MesCobro[i]
      }
      // Guardamos el objeto creado en el array Facturas //
      Facturas.push(Factura);
    }
    return Facturas;
  }

  public VerDebitoxGrupo(database: string, grupo: string){
    return this._http.get(`${environment.api}debito/debito-x-grupo/${database}/${grupo}`); 
  }

  public GuardarDebitos(data){
    return this._http.post(`${environment.api}debito/add-debitos`, {data});
  }



}
